import React, { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { buscarCategoriasConfiguracion } from '../../../actions/configuracion';

import NuevaCategoria from './NuevaCategoria';
import EditarCategoria from './EditarCategoria';
import EliminarCategoria from './EliminarCategoria';

const Categorias = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Categorias',
            path: '/configuracion/categorias'
        }
    ];

    const dispatch =  useDispatch();

    const { listado } = useSelector(state => state.configuracion.categorias);

    const [categorias, setCategorias] = useState([]);

    const [categoriaAgregar, setCategoriaAgregar] = useState(null);
    const [categoriaEditar, setCategoriaEditar] = useState(null);
    const [categoriaEliminar, setCategoriaEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            selector: row => row.nombre, 
            wrap: true
        },
        {
            name: 'Descripción',
            selector: row => row.descripcion,
            wrap: true,
            grow: 2
        },
        {
            name: 'Subcategorias asignadas',
            selector: row => row.subcategorias,
            wrap: true,
            grow: 0.5
        },
        {
            name: '',
            cell: row => {
                return(
                    <div className="text-right w-100">
                        <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarCategoria(row)}><i className="fas fa-trash text-danger"></i></button>
                        <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEditarCategoria(row)}><i className="fas fa-edit text-warning"></i></button>
                        <Link className="btn btn-sm btn-link px-2 float-end" to={`/configuracion/categorias/subcategorias/${row._id}`}><i className="fas fa-list text-info"></i></Link>
                    </div>
                )
            }
        }
    ];

    /* Crear categoria */
    const handleAgregarCategoria = (categoria) => {
        setCategoriaEditar(null);
        setCategoriaEliminar(null);

        setCategoriaAgregar(categoria);        
    }

    /* Editar categoria */
    const handleEditarCategoria = (categoria) => {
        setCategoriaAgregar(null);
        setCategoriaEliminar(null);

        setCategoriaEditar(categoria);
    }

    /* Eliminar categoria */
    const handleEliminarCategoria = (categoria) => {
        setCategoriaAgregar(null);
        setCategoriaEditar(null);

        setCategoriaEliminar(categoria);
    }

    useEffect(() => {
        dispatch(buscarCategoriasConfiguracion());
    }, []);

    useEffect(() => {
        setCategorias(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <NuevaCategoria categoria={categoriaAgregar} reestablecerCategoria={handleAgregarCategoria} />
            <EditarCategoria categoria={categoriaEditar} reestablecerCategoria={handleEditarCategoria} />
            <EliminarCategoria categoria={categoriaEliminar} reestablecerCategoria={handleEliminarCategoria} />

            <div className="row">
                <div className="col-md-12 px-4 pb-4">
                    <h3 className="mb-3 mt-5">Categorias</h3>

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarCategoria({ })}>Agregar categoria</button>
                    </div>

                    <div className="mt-2">
                        <DataTable 
                            columns={columns}
                            data={categorias}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Categorias;